import create from "zustand";

interface UserProfileState {
  firstName: string | null;
  avatarUrl: string | null;
  setProfile: (firstName: string | null, avatarUrl: string | null) => void;
  clearProfile: () => void;
}

export const useUserProfileStore = create<UserProfileState>((set) => ({
  firstName: null,
  avatarUrl: null,
  setProfile: (firstName, avatarUrl) => set({ firstName, avatarUrl }),
  clearProfile: () => set({ firstName: null, avatarUrl: null }),
}));
